"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sink = void 0;
const utils_1 = require("./utils");
class Sink {
    constructor(getStore) {
        this.reducers = {};
        this.effects = {};
        this.instance = {};
        this.stateNames = {};
        this.triggers = [];
        this.getStore = getStore;
    }
    setState(state) {
        this.state = state;
    }
    dispatch(name, payload, effect) {
        const store = this.getStore();
        const type = this.actions[name];
        return store && store.dispatch({ effect, payload, type });
    }
    get reducerActions() {
        if (!this._reducerActions) {
            this._reducerActions = this.getAction(Object.keys(this.reducers), this.namespace);
        }
        return this._reducerActions;
    }
    get effectActions() {
        if (!this._effectActions) {
            this._effectActions = this.getAction(Object.keys(this.effects), this.namespace);
        }
        return this._effectActions;
    }
    get reducer() {
        if (!this._reducer) {
            const reducer = Object.keys(this.reducers).reduce((map, key) => (map[this.actions[key]] = this.reducers[key], map), {});
            this._reducer = utils_1.buildReducer(this.state, reducer);
        }
        return this._reducer;
    }
    get actions() {
        if (!this._actions) {
            this._actions = Object.assign({}, this.effectActions, this.reducerActions);
        }
        return this._actions;
    }
    get dispatches() {
        if (!this._dispatches) {
            const reducerDispatches = this.getReducerDispatches(Object.keys(this.reducerActions));
            const effectDispatches = this.getEffectDispatches(Object.keys(this.effectActions));
            this._dispatches = Object.assign({}, reducerDispatches, effectDispatches);
        }
        return this._dispatches;
    }
    getAction(keys, namespace) {
        return keys.reduce((accumulate, current) => (accumulate[current] = `${namespace}/${current}`, accumulate), {});
    }
    getReducerDispatches(keys) {
        return keys.reduce((dispatches, key) => (dispatches[key] = (value) => this.dispatch(key, value, false), dispatches), {});
    }
    getEffectDispatches(keys) {
        return keys.reduce((dispatches, key) => (dispatches[key] = (...args) => this.dispatch(key, args, true), dispatches), {});
    }
}
exports.Sink = Sink;
